import { render, staticRenderFns } from "./ComplexityParameters.vue?vue&type=template&id=246e2e3c"
import script from "./ComplexityParameters.vue?vue&type=script&lang=js"
export * from "./ComplexityParameters.vue?vue&type=script&lang=js"
import style0 from "./ComplexityParameters.vue?vue&type=style&index=0&id=246e2e3c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports